exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pricelist-table-inner[data-v-34668b29]{max-width:1430px;margin:50px auto 0}.theatre-dialog[data-v-34668b29]{width:100%;min-height:100vh;max-width:100%;overflow-y:scroll}.theatre-dialog .md-toolbar.md-theme-default .md-title[data-v-34668b29]{color:rgba(0,0,0,.87)}.theatre-dialog .theatre-container[data-v-34668b29]{min-height:calc(100vh - 130px);width:calc(100% - 400px)}.theatre-dialog .theatre-container .theatre-seats[data-v-34668b29]{width:100%}.theatre-dialog .theatre-container .theatre-seats-holder[data-v-34668b29]{min-height:calc(100vh - 250px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-34668b29","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/Admin/Tickets/Performances.vue
// module id = 308
// module chunks = 0